import createTheme from "@mui/material/styles/createTheme";
import { AUDIT_TOKENS } from "./auditTokens";
import { themeOptions } from "@/theme";

/** The app theme with the audit page's font stack and control shapes layered on top. */
export const auditTheme = createTheme({
  ...themeOptions,
  typography: {
    fontFamily: AUDIT_TOKENS.fontFamily,
    fontSize: 13.5,
  },
  shape: { borderRadius: AUDIT_TOKENS.radius.control },
  palette: {
    ...themeOptions.palette,
    text: { primary: AUDIT_TOKENS.text, secondary: AUDIT_TOKENS.muted },
    background: { default: AUDIT_TOKENS.bg, paper: AUDIT_TOKENS.surface },
    divider: AUDIT_TOKENS.line,
  },
  components: {
    MuiButtonBase: {
      styleOverrides: {
        root: {
          "&.Mui-focusVisible": {
            outline: AUDIT_TOKENS.focusRing,
            outlineOffset: 1,
          },
        },
      },
    },
    MuiOutlinedInput: {
      styleOverrides: {
        root: {
          backgroundColor: AUDIT_TOKENS.surface,
          "& .MuiOutlinedInput-notchedOutline": { borderColor: AUDIT_TOKENS.line },
          "&:hover .MuiOutlinedInput-notchedOutline": { borderColor: AUDIT_TOKENS.lineHover },
        },
      },
    },
    MuiTooltip: {
      defaultProps: { arrow: true },
    },
  },
});
